import { render, staticRenderFns } from "./QcqShiftBreakDialog.vue?vue&type=template&id=88ba04a2&scoped=true&lang=pug&"
import script from "./QcqShiftBreakDialog.vue?vue&type=script&lang=ts&"
export * from "./QcqShiftBreakDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ba04a2",
  null
  
)

export default component.exports